export default __webpack_public_path__ + "static/media/close.74704861.svg";